export default __webpack_public_path__ + "static/media/award-1.ce998c5e.png";